import styled from '@emotion/styled';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const Container = styled.section`
  border-bottom: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
`;

export const StyledHTitle3 = styled(H.Title3)`
  text-align: center;
  padding: 56px 0;
  border-bottom: var(--border-grid, 1px solid ${COLORS3.BLACK_030});

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} 0;
    span {
      display: block;
    }
  }
`;

export const TestimonialContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${MEDIA_QUERY_V2.MOBILE_XS} {
    overflow-x: scroll;
    margin: ${SPACING.S24} 0;
    padding-left: ${SPACING.S24};

    // Override webkit scrollbar to allows show
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 6px;
    }
    ::-webkit-scrollbar-track {
      background: ${COLORS3.BLACK_005};
      margin: 0 ${SPACING.S24};
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${COLORS3.BLACK_030};
      border-radius: 100px;
    }
  }
`;

export const Testimonial = styled.div`
  width: 100%;
  background-color: ${COLORS3.BLACK_005};
  border-radius: var(--border-radius-md, ${SPACING.S16});
  margin: ${SPACING.S16};
  padding: ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE_XS} {
    width: 300px;
    justify-content: flex-start;
    flex-shrink: 0;
    margin: 0 ${SPACING.S16} ${SPACING.S24} 0;
  }

  ${MEDIA_QUERY_V2.TABLET} {
    padding: ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    padding: ${SPACING.LG};
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    padding: 56px;
  }

  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    padding: 64px;
  }
`;

export const Name = styled(P.BodyBase)`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin-bottom: ${SPACING.XXS};
`;

export const TestimonialTitle = styled(P.BodyBase)`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: ${SPACING.S16} 0 ${SPACING.XS};
`;

export const Divider = styled.div`
  border-right: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
  ${MEDIA_QUERY_V2.MOBILE_XS} {
    display: none;
  }
`;
